export default __webpack_public_path__ + "static/media/cloud-upload.2643075d.png";